import type { ReactElement } from 'react';

import { TraverseItem } from 'hb-builder/components/Renderer/TraverseItem';

export const ChildrenRenderer = ({ item }): ReactElement => {
  const children = item?.children?.filter(Boolean);

  return children.map((child) => <TraverseItem key={child.id} item={child} />);
};
